import React from "react";
import ImageBanner from "@/components/ImageBanner";
import Card from "@/components/Card";
import Footer from "@/layout/Footer";
const SuccessStories = () => {
	const interestingArticles = [
		{
			imageSrc: "assets/success-stories/xl/interestingArticles/image1.svg",
			title: `Unleashing Potential:\nA Trailblazing Journey with\nRetail Arbitrage Dropshipping.`,
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success.",
			date: "29 Aug, 2024",
			buttonText: "Read More",
		},
		{
			imageSrc: "assets/success-stories/xl/interestingArticles/image2.svg",
			title: `Accelerating Growth:\nA Success Story with Retail\nArbitrage Dropshipping.`,
			description:
				"Discover how strategic planning and dedication turned a side hustle into a 6-figure business.",
			date: "15 Sep, 2024",
			buttonText: "Discover",
		},
	];

	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Success Stories"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>

			<div className="relative flex flex-col w-full max-w-[1300px] h-[560px] mt-[70px] mx-auto rounded-[5px] hidden lg:flex">
				{/* Image (on left, partially over content box) */}
				<div className="absolute top-[28px] left-0 w-[380px] h-[504px] rounded-[5px] z-10 overflow-hidden shadow-xl">
					<img
						src="assets/success-stories/xl/man.svg"
						alt="Johnson"
						className="w-full h-full object-cover rounded-[5px]"
					/>
				</div>

				{/* Background content box (now on right) */}
				<div className="relative ml-auto w-[994px] h-[560px] bg-[#E9F2F4] rounded-[5px] z-0 pl-[104px] pr-[60px] py-[40px]">
					<p className="w-[232px] font-semibold text-[13px] text-[#193D34] font-['Montserrat'] leading-[1.5] mb-[30px]">
						Scaling from <br />
						Dropshipping to Brand Ownership
					</p>
					<div className="flex flex-col gap-[10px] text-[13px] font-medium text-[#193D34] font-['Montserrat'] leading-[1.6] max-w-[880px]">
						<p>
							Alex Nguyen's journey in e-commerce began with a laptop. Like many
							aspiring entrepreneurs, he started by exploring dropshipping
							opportunities through platforms like AliExpress. Initially, Alex
							faced common challenges associated with dropshipping: long
							shipping times, inconsistent product quality, and fierce
							competition.
						</p>
						<p>
							Undeterred, Alex recognized the potential to carve out a niche in
							the electronics market. Armed with a passion for technology and a
							keen eye for emerging trends, he meticulously researched trending
							products and consumer preferences. This research led him to
							identify a gap in the market for premium tech accessories that
							combined functionality with style.
						</p>
						<p>
							Determined to offer superior products and customer service, Alex
							decided to transition from dropshipping to establishing his own
							brand. This shift allowed him greater control over product
							quality, shipping times, and customer satisfaction. He forged
							partnerships with reliable suppliers who shared his commitment to
							excellence.
						</p>
						<p>
							To drive initial sales and brand awareness, Alex leveraged digital
							marketing strategies, particularly Facebook ads and influencer
							partnerships. By targeting tech enthusiasts and early adopters, he
							quickly gained traction in the competitive electronics market. The
							combination of compelling product offerings, strategic marketing,
							and exceptional customer support propelled Alex's brand to
							success.
						</p>
						<p>
							Within a year of launching his brand, Alex surpassed $500,000 in
							revenue. His products gained recognition for their innovative
							designs and premium quality, attracting a loyal customer base.
							Today, Alex continues to expand his product line and explore new
							opportunities in the tech industry. His journey from dropshipping
							novice to successful brand owner underscores the transformative
							power of strategic pivots and unwavering dedication in e-commerce.
						</p>
					</div>
				</div>
			</div>
			<div className="relative flex flex-col w-full max-w-[1300px] h-[560px] mt-[70px] mx-auto rounded-[5px] hidden lg:flex">
				{/* Background content box (now on left) */}
				<div className="relative mr-auto w-[994px] h-[560px] bg-[#E9F2F4] rounded-[5px] z-0 pl-[34px] pr-[60px] py-[40px]">
					<p className="w-[232px] font-semibold text-[13px] text-[#193D34] font-['Montserrat'] leading-[1.5] mb-[30px]">
						Harnessing Video <br />
						Marketing for Niche Products
					</p>

					<div className="flex flex-col gap-[10px] text-[13px] font-medium text-[#193D34] font-['Montserrat'] leading-[1.6] max-w-[880px]">
						<p>
							Sarah Johnson's entrepreneurial journey began with a passion for
							fitness and a keen interest in innovative workout gear. As a
							fitness enthusiast herself, Sarah noticed a gap in the market for
							high-performance fitness equipment that catered to serious
							athletes and fitness enthusiasts. Starting small with retail
							arbitrage to test product demand, Sarah quickly identified
							promising opportunities in niche e-commerce. She recognized that
							traditional marketing methods alone wouldn't suffice in showcasing
							the unique features and benefits of her products. This realization
							led Sarah to explore the untapped potential of video marketing.
						</p>
						<p>
							Sarah embarked on a strategic video marketing campaign aimed at
							highlighting her products' functionality, durability, and user
							testimonials. Collaborating with fitness influencers and producing
							high-quality video content, she effectively conveyed the value of
							her fitness equipment to her target audience. Platforms like
							Instagram and YouTube became her primary channels for engaging
							with fitness enthusiasts and potential customers.
						</p>
						<p>
							The impact of Sarah's video marketing strategy was profound. Not
							only did it drive significant traffic to her online store, but it
							also positioned her brand as a leader in the niche fitness market.
							By showcasing real-world applications of her products and
							fostering genuine connections with her audience, Sarah remarkably
							increased sales and brand loyalty.
						</p>

						<p>
							Within two years of launching her e-commerce venture, Sarah's
							business surpassed $250,000 in annual revenue. Her success
							underscores the transformative potential of video marketing in
							niche markets, demonstrating how compelling storytelling and
							authentic engagement can drive substantial growth in e-commerce.
						</p>
					</div>
				</div>

				{/* Image (now on the right, over background) */}
				<div className="absolute top-[28px] right-0 w-[380px] h-[504px] rounded-[5px] z-10 overflow-hidden shadow-xl">
					<img
						src="assets/success-stories/xl/woman.svg"
						alt="Johnson"
						className="w-full h-full object-cover rounded-[5px]"
					/>
				</div>
			</div>

			<div className="relative flex flex-col w-full max-w-[1300px] h-[476px] mt-[50px] mx-auto rounded-[5px]  hidden lg:flex">
				{/* Center aligned heading */}
				<h2 className="text-[13px] font-semibold leading-[1] text-center text-[#193D34] font-['Montserrat']">
					Interesting Articles
				</h2>

				{/* Cards container */}
				<div className="flex flex-col-2 gap-10 mt-4">
					{interestingArticles.map((card) => (
						<Card key={card.id} content={card} variant="interestingArticles" />
					))}
				</div>
			</div>

			{/* Mobile View  */}

			<ImageBanner type="mobile" title="Success Stories" />
			<div className="relative flex flex-col w-full px-4 py-6 bg-[#E9F2F4] rounded-[5px] mt-[40px] sm:flex md:flex lg:hidden">
				{/* Image */}
				<div className="w-full h-[406px] rounded-[5px] overflow-hidden mb-4">
					<img
						src="assets/success-stories/xl/man.svg"
						alt="Alex Nguyen"
						className="w-full h-full object-cover rounded-[5px]"
					/>
				</div>

				{/* Title */}
				<p className="font-semibold text-[16px] text-[#193D34] font-['Montserrat'] leading-tight mb-3">
					Scaling from <br /> Dropshipping to Brand Ownership
				</p>

				{/* Content */}
				<p className="font-['Montserrat'] font-medium text-[13px] leading-[100%] tracking-[0] text-[#193D34] whitespace-pre-line">
					Alex Nguyen's journey in e-commerce began with a laptop. Like many
					aspiring{"\n"} entrepreneurs,
					{"\n"}he started by exploring dropshipping{"\n"} opportunities through
					platforms like{"\n"} AliExpress. Initially,
					{"\n"}Alex faced common challenges associated {"\n"} with
					dropshipping: long shipping times,{"\n"} inconsistent
					{"\n"}product quality, and fierce competition.
					{"\n\n"}Undeterred, Alex recognized the potential to carve out a niche
					in the electronics market.{"\n"} Armed
					{"\n"}with a passion for technology and a keen eye for emerging
					trends, he meticulously {"\n"}researched
					{"\n"}trending products and consumer {"\n"} preferences. This research
					led him to identify a gap in the
					{"\n"}market for premium tech accessories that combined functionality
					with style.
					{"\n\n"}Determined to offer superior products and .{"\n"} customer
					service, Alex decided to transition .{"\n"} from
					{"\n"}dropshipping to establishing his own brand..{"\n"} This shift
					allowed him greater control over.{"\n"} product
					{"\n"}quality, shipping times, and customer .{"\n"} satisfaction. He
					forged partnerships with.{"\n"} reliable suppliers
					{"\n"}who shared his commitment to excellence.
					{"\n\n"}To drive initial sales and brand awareness,.{"\n"} Alex
					leveraged digital marketing strategies,
					{"\n"}particularly Facebook ads and influencer.{"\n"} partnerships. By
					targeting tech enthusiasts.{"\n"} and early
					{"\n"}adopters, he quickly gained traction in the .{"\n"} competitive
					electronics market. The .{"\n"} combination of
					{"\n"}compelling product offerings, strategic.{"\n"} marketing, and
					exceptional customer .{"\n"} support propelled.{"\n"}
					{"\n"}Alex's brand to success.
					{"\n\n"}Within a year of launching his brand, Alex .{"\n"} surpassed
					$500,000 in revenue. His products .{"\n"} gained
					{"\n"}recognition for their innovative designs and .{"\n"} premium
					quality, attracting a loyal customer base.
					{"\n"}Today, Alex continues to expand his product.{"\n"} line and
					explore new opportunities in the tech.{"\n"}
					{"\n"}industry. His journey from dropshipping.{"\n"} novice to
					successful brand owner.{"\n"} underscores the
					{"\n"}transformative power of strategic pivots and unwavering
					dedication in e-commerce.
				</p>
			</div>
			<div className="relative flex flex-col w-full px-4 py-6 mt-6 rounded-[5px] flex lg:hidden">
				{/* Center aligned heading */}
				<h2 className="text-[13px] font-semibold leading-[1] text-center text-[#193D34] font-['Montserrat']">
					Interesting Articles
				</h2>

				{/* Cards container */}
				<div className="grid grid-cols-1 gap-4 mt-4">
					{interestingArticles.map((card) => (
						<Card
							key={card.id}
							content={card}
							variant="interestingArticlesMobile"
						/>
					))}
				</div>
			</div>

			<Footer />
		</>
	);
};

export default SuccessStories;
